<template lang="pug">
div
  .mb-2
    select.form-control(v-model="ewalletId" @change="selectEwallet")
      option(selected value="") {{ $t('ui.please_select_ewallet') }}
      template(v-if="ewalletList.length > 0")
        option(v-for="ewallet in ewalletList" :value="ewallet.aa") {{ewallet.bank_name}} ({{ewallet.bank_acc_no}})
  template(v-if="ewalletList.length > 0 && ewalletId !==''")
    .mb-2
      label.col-form-label {{ $t("ui.bank_ewallet") }} :
      input.form-control.input-disabled(type="text" :placeholder="ewalletName" disabled)
    .mb-2
      label.col-form-label {{ $t("ui.bank_ewalletname") }} :
      input.form-control.input-disabled(type="text" :placeholder="ewalletHolder" disabled)
    .mb-2
      label.col-form-label {{ $t("ui.bank_ewalletno") }} :
      input.form-control.input-disabled(type="text" :placeholder="ewalletNo" disabled)
    //- .mb-2
      label.col-form-label {{ $t("ui.status") }} :
        span.text-uppercase(:class="getColor(ewalletStatus)") &nbsp;{{getText(ewalletStatus)}}
  //- activeDisplay(v-if="activeList.length>0" :activeCount="activeList[0].active" :inactiveCount="activeList[0].inactive" :totalCount="activeList[0].total")
  activeDisplay(:displayType="'EWALLET'")
  //- .mt-5.mb-2.d-flex.flex-column.align-items-start(v-if="activeList.length>0")
    //- .tooltips.me-2
    //-   i.fa.fa-info-circle 
    //-   span.tooltipstext Green indicates active number, Red indicates inactive number
    .text-uppercase {{$t('ui.accounts')}} : 
      span.text-activeacc.ms-2.fw-bold {{activeList[0].active}}
      span.text-inactiveacc.fw-bold ({{activeList[0].inactive}}) 
      span / {{activeList[0].total}} 
    div
      .box-activeacc
      span &nbsp;&nbsp;: {{$t('ui.active')}}
    div
      .box-inactiveacc 
      span &nbsp;&nbsp;: {{$t('ui.inactive')}}
</template>
<script>
import activeDisplay from '@/component/_activeList.vue'
export default {
  components:{
    activeDisplay
  },
  data(){
    return{
      ewalletList: [],
      ewalletId: "",
      ewalletName: "",
      ewalletNo: "",
      ewalletHolder: "",
      ewalletStatus: "",
    }
  },
  computed: {
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
  },
  created(){
    this.getMemberEwallet()
  },
  methods:{
    getMemberEwallet(){
      if (this.sessionToken) {
        let account_id = this.accountID
        let auth_token = this.sessionToken
        this.$store
          .dispatch("user/getMemberEwallet", { account_id, auth_token })
          .then(response => {
            if (response.success == true) {
              response.data.filter(x=> x.status===true).forEach((y, index) => {
                y.aa = "e-" + index
                this.ewalletList.push(y)
              })
              // for(var i = 0; i< response.data.length; i++){
              //   response.data[i].aa = "e-" + i
              // }
              // this.ewalletList = response.data
            } else {
              if((typeof response.status) != 'object'){
                this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
              }    
            }
          })
          .catch(response => {
            if((typeof response.status) != 'object'){
              this.$helpers.showDialog(this.$t("ui.attention"), this.$t("message.list." + response.status), "info", this);
            }
          });
      }
    },
    selectEwallet(){
      this.ewalletList.filter(x => x.aa === this.ewalletId).forEach(y => {
        this.ewalletHolder = y.bank_acc_holder
        this.ewalletNo = y.bank_acc_no
        this.ewalletName = y.bank_name
        this.ewalletStatus = y.status
      })
    },
    getText(status){
      if(status === true){
        var tag = "active"
      }else{
        var tag = "inactive"
      }
      return this.$t('ui.'+tag);
    },
    getColor(status){
      if(status === true){
        return "text-success"
      }else{
        return "text-danger"
      }
    }
  }
}
</script>
<style lang="scss" scoped>
// select {
//   -webkit-appearance: listbox !important;
// }

</style>